import { useToast } from "../context/ToastContext";

const ICON = { success: "✅", error: "⚠️", info: "ℹ️" };

// Rendered once at the app root. Toasts supplement (never replace) the
// existing inline error/success text already shown on each page — same
// message, shown in both places.
export default function ToastContainer() {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`} onClick={() => dismiss(t.id)}>
          <span className="toast-icon">{ICON[t.type] || ICON.info}</span>
          <span className="toast-text">{t.text}</span>
        </div>
      ))}
    </div>
  );
}
